export default __webpack_public_path__ + "static/media/Layer_5@2x.eec17070.png";